<template>
  <div>
    <a
      class="button-back-to-top"
      href="#"
      @click="scrollToTop()"
    >
      <div class="label">Retour en haut de page</div>
      <svg class="icon-arrow">
        <use xlink:href="#icon-arrow2"></use>
      </svg>
    </a>
  </div>
</template>

<script>

export default {
  name: 'ButtonBackToTop',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../sass/config/vars";
@import "../../../sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.button-back-to-top {
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
}

.icon-arrow {
  height: 1.3rem;
  transform: rotate(-90deg);
  width: 0.8rem;
}

.label {
  color: #000;
  font-family: $f-graphie-book;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: normal;
  line-height: 5.8rem;
  margin-right: 1.5rem;
}

</style>
